import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { IMG } from "../../data/content";
import { Chapter, Reveal, EASE } from "../shared";

export default function StoryTeaser() {
  return (
    <section className="bg-ivory py-24 md:py-32" data-testid="story-teaser">
      <div className="mx-auto grid max-w-7xl items-center gap-16 px-6 md:grid-cols-2 md:px-12">
        <div className="relative">
          <Reveal>
            <div className="gold-frame arch overflow-hidden">
              <img src={IMG.teaserA} alt="The Big Wedd celebration" loading="lazy" className="h-[420px] md:h-[560px] w-full object-cover" />
            </div>
          </Reveal>
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 1, delay: 0.25, ease: EASE }}
            className="absolute -bottom-10 -right-2 md:right-[-3rem] w-44 md:w-64 border-4 border-ivory shadow-2xl"
          >
            <img src={IMG.teaserB} alt="Celebration detail" loading="lazy" className="h-56 md:h-80 w-full object-cover" />
          </motion.div>
          <div className="pointer-events-none absolute -left-6 -top-6 hidden h-24 w-24 rotate-45 border border-gold/40 md:block" />
        </div>
        <div className="md:pl-8">
          <Chapter num="01" title="Our Story" />
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-serif text-4xl md:text-6xl leading-[1.05] text-emerald">
              Timeless weddings,<br /><span className="italic text-gold-text">beautifully engineered</span>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-8 text-base leading-relaxed text-stone2">
              At The Big Wedd, we are a team of professionals passionate about designing timeless, luxurious weddings and memorable celebrations.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <p className="mt-5 text-base leading-relaxed text-stone2">
              As destination wedding planners working across Rajasthan, Goa, Rishikesh and destinations across India and abroad, we bring together creativity, planning, design, hospitality and flawless execution under one roof.
            </p>
          </Reveal>
          <Reveal delay={0.4}>
            <p className="mt-5 text-base leading-relaxed text-stone2">
              From the first idea to the final farewell, we manage every detail of your celebration so you can be present in the moment.
            </p>
          </Reveal>
          <Reveal delay={0.5}>
            <Link to="/about" data-testid="story-teaser-link" className="group mt-10 inline-flex items-center gap-4 text-[11px] font-medium uppercase tracking-[0.25em] text-emerald">
              <span className="border-b border-gold pb-1 transition-colors group-hover:text-gold-text">Discover Our Story</span>
              <span className="text-gold transition-transform duration-300 group-hover:translate-x-2">→</span>
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
